import {Http} from '../../../Data/config/Http';
import {ProductType} from '../models/productType.model';
import {API_ROUTES} from '../../../constants/apiRoutes';
import type {BaseResponse} from '../../../Data/types/BaseResponse';
import {unwrapResponse, handleDataSourceError} from '../../../utils/errorHelpers';

export const ProductTypeAPIDataSource = {
  getProductTypes: async (): Promise<ProductType[]> => {
    try {
      const response = await Http.get<BaseResponse<ProductType[]>>(API_ROUTES.PRODUCTS.TYPES);
      return unwrapResponse(response.data, 'حدث خطأ في جلب أنواع المنتجات');
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  createProductType: async (payload: { name: string; description?: string }): Promise<ProductType> => {
    try {
      const response = await Http.post<BaseResponse<ProductType>>(API_ROUTES.PRODUCTS.TYPES, payload);
      return unwrapResponse(response.data, 'فشل في إضافة نوع المنتج', [200, 201]);
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  updateProductType: async (id: number, payload: { name: string; description?: string }): Promise<ProductType> => {
    try {
      const response = await Http.put<BaseResponse<ProductType>>(API_ROUTES.PRODUCTS.TYPE_BY_ID(id.toString()), payload);
      return unwrapResponse(response.data, 'فشل في تعديل نوع المنتج');
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  deleteProductType: async (id: number): Promise<void> => {
    try {
      const response = await Http.delete<BaseResponse<void>>(API_ROUTES.PRODUCTS.TYPE_BY_ID(id.toString()));
      unwrapResponse(response.data, 'فشل في حذف نوع المنتج', [200, 204]);
    } catch (error) {
      handleDataSourceError(error);
    }
  }
};

